import React from 'react';
import PropTypes from 'prop-types';
import { passengersShape } from 'constants/propTypes';
import { StyledSummaryPaxs, StyledPaxsTable } from '../ExchangeSummary.styles';
import { StyledTD, StyledTR } from 'components/shared/JourneyDigest/JourneyDigest.styles';

import PassengerType from 'components/ui/PassengerType';
import { passengerSummary } from '../ExchangeSummary.utils';

const ExchangeSummaryPaxs = ({ passengers, isGroup }) => {
  const paxs = passengerSummary({ passengers });

  return (
    <StyledSummaryPaxs>
      <StyledPaxsTable>
        <tbody>
          {Object.values(paxs)?.map(({ count, type, disabilityType, bucketCode }) => (
            <StyledTR data-testid="pax-details" data-id="pax-details" key={`${type}-${disabilityType}-${count}`}>
              <StyledTD>
                {`${count} x `}
                <PassengerType type={type} disabilityType={disabilityType} />
              </StyledTD>
              {isGroup && <StyledTD>({bucketCode})</StyledTD>}
            </StyledTR>
          ))}
        </tbody>
      </StyledPaxsTable>
    </StyledSummaryPaxs>
  );
};

ExchangeSummaryPaxs.propTypes = {
  isGroup: PropTypes.bool,
  passengers: passengersShape
};

export default ExchangeSummaryPaxs;
